'use es6';

export const chain = (...processors) => (...args) => response => processors.reduce((processed, processor) => processor(...args)(processed), response);